/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-09 15:59:58
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-09 17:30:28
 * @name: 主要配置
 * @Description: 主要配置
 * @FilePath: \preSaleNafterSaleInside\project\src\config\main.config.js
 * @Author: desktop
 */
// 浏览器便签标题
module.exports = {
  title: '售前售后管理系统',
}